<template>
  <teleport v-if="widget" :to="'#' + dest">
    <div
      class="orm-carcategoryslider"
      :class="!disablecontainer ? 'orm-container orm-py-56' : ''"
    >
      <div class="orm-row orm-mb-32" v-if="!disablecontainer">
        <div class="orm-col-xs-12 text-center">
          <h2
            class="orm-headline__h1"
            v-html="
              i18n('modules/abov2/title') ||
                'Neues Auto? Da hätten wir was für euch'
            "
          ></h2>
        </div>
      </div>
      <div class="orm-row center-xs center-md" v-if="carGroup?.length > 0">
        <AboCarGroup
          v-for="car in carGroup"
          :key="car.id"
          :data="car"
          :filter="true"
        />
      </div>

      <div v-else>
        <div
          class="orm-preload-page orm-preload-page-static"
          v-if="!disablecontainer"
        >
          <i class="fa fa-spinner-third orm-rotate360"></i>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { defineComponent, toRef } from "vue";
import store from "@/store";
import i18n from "@/mixins/mixins";
import stripHTML from "@/mixins/mixins";
import AboCarGroup from "@/components/cargroup/AboCarGroup.vue";

export default defineComponent({
  name: "AboV2VehicleGroups",
  components: { AboCarGroup },
  mixins: [i18n, stripHTML],
  setup(props) {
    const dest = toRef(props, "teleport").value;
    let widget = false;
    const myEle = document.getElementById(dest);
    if (myEle !== null) {
      widget = true;
    }

    return {
      widget,
      dest,
      // offers,
    };
  },
  data() {
    return {
      carGroup: null,
      offers: null,
      demo: process.env.VUE_APP_DEMO,
      carcategory: [],
      sttype: "ALL",
      disablecontainer: false,
      filtercategory: null,
    };
  },
  props: {
    teleport: {
      type: String,
      default: "crentAboVehicleGroups",
    },
  },
  async created() {
    const teleportWrapper = document.getElementById(this.teleport);
    if (teleportWrapper == null) {
      return;
    }

    await store.dispatch("cargroup/SET_CARGROUPS_ALL");
    const carGroups = await store.getters["cargroup/GET_GLOBAL_CARGROUPS"];
    this.carGroup = JSON.parse(JSON.stringify(carGroups));
  },
  methods: {},
});
</script>
